import axios from "axios";
import authHeader, { twoFactorAuthHeader } from "./AuthHeader";
import cookie from 'react-cookies'

const setupTransactionPin = ( pim) =>{
    const tokens = cookie.load('jwttoken')
    const value = { "transactionPin":pim}

    return axios.post('/api/set-pin', value,{
        headers: {
          'Authorization': tokens 
        }
      } )
}


const userLogin = (email, password) =>{
    const value = {"emailAddress": email, "password": password, 'channel':'web'}
    return axios.post(`/api/admin/user-login-admin`, value)
}
const uploadProperty = (bathrooms,bedrooms,coveredArea,description,locality,price,propertyDuration,propertyId,propertyType, street, title, toilets, totalArea, transactionPin, videoLink) =>{
    const value = {"bathrooms": bathrooms, "bedrooms": bedrooms, "coveredArea": coveredArea, "description":description, "locality": locality,"price":price, "propertyDuration":propertyDuration,"propertyId": propertyId,"propertyType":propertyType,"street":street, "title":title, "toilets": toilets, "totalArea":totalArea, "transactionPin":transactionPin,"videoLink":videoLink}
    return axios.post(`/api/upload-properties`, value, { headers: authHeader()})
}
const uploadProject = (contact,priceperunit,projectLocation,projectDescription,projectDuration,projectLink,projectName, projectType, rate, totalUnits, transactionPin, file,earlyExit ) =>{
    const formData = new FormData();
    formData.append('contact', contact);
    formData.append('earlyExit', earlyExit);
    formData.append('pricePerUnit', priceperunit);
    formData.append('projectLocation', projectLocation);
    formData.append('projectDescription', projectDescription);
    formData.append('projectDuration', projectDuration);
    formData.append('projectLink', projectLink);
    formData.append('projectName', projectName);
    formData.append('projectType', projectType);
    formData.append('rate', rate);
    formData.append('totalUnits', totalUnits);
    formData.append('transactionPin', transactionPin);
    file.forEach((image) => {
        formData.append('file', image);
      });
    return axios.post(`/api/upload-project`, formData, { headers: authHeader()})
}

const uploadProjectt = (value) =>{

    return axios.post('/api/upload-project', value, { headers: authHeader()} )
}
const uploadPropertyListing = (value) =>{
    return axios.post('/api/upload-properties', value, { headers: authHeader()} )
}
const uploadlandListing = (value) =>{
    return axios.post('/api/land-listing', value, { headers: authHeader()} )
}

const userInvite = (email, lastName, firstName, userRole, ) =>{
    const value = {"emailAddress": email, "firstName": firstName, "lastName": lastName,  "userRole":userRole }
    return axios.post(`/api/admin/invite-user`, value, { headers: authHeader()})
}
const userCompleteSignup = (phoneNumber, password, transactionPin,uuid) =>{
    const value = {"phoneNumber": phoneNumber, "password": password, "uuid":uuid, "transactionPin":transactionPin}
    return axios.post(`/api/admin/complete-signup-admin`, value)
}
const deactivateUser = (id, pin) =>{
    const value = {}
    return axios.post(`/api/admin/deActivate-user?id=${id}&transactionPin=${pin}`, value, { headers: authHeader()})
}

const activateUser = (id, pin) =>{
    const value = {}
    return axios.post(`/api/activate-user?id=${id}&transactionPin=${pin}`, value, { headers: authHeader()})
}
const changePin = (oldPin, newPin) =>{
    const value = {"newPin": newPin, "oldPin": oldPin }
    return axios.post(`/api/admin/change-pin-admin`, value, { headers: authHeader()})
}
const changePassword = (oldPassword, newPassword) =>{
    const value = {"newPassword": newPassword, "oldPassword": oldPassword }
    return axios.post(`/api/admin/change-password-admin`, value, { headers: authHeader()})
}
const forgetPassMail = (email) =>{
    const value = {}
    return axios.post(`/api/admin/forgot-password-admin?emailAddress=${email}`, value, { headers: authHeader()})
}
const conForgetPassMail = (otp, pass, requestId) =>{
    const value = {"requestId":requestId,"otp":otp,"password":pass}
    return axios.post(`/api/admin/reset-password-admin`, value, { headers: authHeader()})
}
const addNotification = (header,  content) =>{
    const value = {"content":content,"title":header,}
    return axios.post(`/api/admin/notifications`, value, { headers: authHeader()})
}

const validateOtp = (totp,  username) =>{
    const value = {"username":username,"totp":totp,}
    return axios.post(`/api/admin/validateTotp`, value, { headers: twoFactorAuthHeader() })
}

const resetOtpp = (otp,  requestId, pin) =>{
    const value = {"requestId":requestId,"otp":otp,"pin":pin}
    return axios.post(`/api/admin/reset-pin-admin`, value, { headers: twoFactorAuthHeader() })
}
const reset2fa = (otp,  requestId, ) =>{
    const value = {"requestId":requestId,"otp":otp,}
    return axios.post(`/api/admin/reset-2fa-admin`, value, { headers: twoFactorAuthHeader() })
}
const forgetPin = () =>{
    const value = {}
    return axios.post(`/api/admin/forgot-pin-admin`, value, { headers: twoFactorAuthHeader() })
}
const changeRole = (emailAddress,  newRole, transactionPin) =>{
    const value = {"newRole":newRole,"emailAddress":emailAddress,"transactionPin":transactionPin}
    return axios.post(`/api/admin/change-role`, value, { headers: authHeader()})
}
const deactivateAdminUser = (id, transactionPin) =>{
    const value = {}
    return axios.post(`/api/admin/de-activate-user-admin?id=${id}&transactionPin=${transactionPin}`, value, { headers: authHeader()})
}
const activateAdminUser = (id, transactionPin) =>{
    const value = {}
    return axios.post(`/api/admin/activate-user-admin?id=${id}&transactionPin=${transactionPin}`, value, { headers: authHeader()})
}
const addRate = (duration, rate) =>{
    const value = {"duration": duration, "rate":rate}
    return axios.post(`/api/set-duration`, value, { headers: authHeader()})
}
const updateProperty = (contact, description, locality,propertyId,title,pin) =>{
    const value = {"contact": contact, "description":description,"transactionPin":pin, "locality":locality, 'propertyId':propertyId, "title":title}
    return axios.post(`/api/edit-properties`, value, { headers: authHeader()})
}
const updateProject = (contact, projectDescription, projectLocation,propertyId,title,pin) =>{
    const value = {"contact": contact, "projectDescription":projectDescription,"transactionPin":pin, "projectLocation":projectLocation, 'projectId':propertyId, "title":title}
    return axios.post(`/api/edit-project`, value, { headers: authHeader()})
}

const uploadAsset = (categoryId, data) => {
    return axios.post(`/api/admin/asset/categories/${categoryId}/products`, data, { 
        headers: authHeader() 
    });
}

const approveAssetRecommendation = (recommendationId, categoryId, data) => {
    return axios.post(`/api/admin/asset/recommendations/${recommendationId}/approve/categories/${categoryId}`, data, {
        headers: authHeader()
    });
}

const CreateInvestmentPlan= (data)=>{
    return axios.post('/api/admin/investments', data,{ headers: authHeader()});
}

const createInvestmentCategory= (data)=>{

    return axios.post('/api/admin/investments/investment-category', data,{ headers: authHeader()});
}

const createAssestCategory= (data)=>{

    return axios.post('/api/admin/asset/categories', data,{ headers: authHeader()});
}

const Logout= (data)=>{

    return axios.post('/api/admin/logout', data,{ headers: authHeader()});
}
const createSavingsCategory= (data)=>{
    return axios.post('/api/admin/savings/savings-category', data,{ headers: authHeader()});
}
const reconcileWalletFunding = (reference, data) => {
    return axios.post(`/api/admin/wallet/transactions/${reference}/reconcile`, data, { 
        headers: authHeader() 
    });
}

const matureInvestment = (investmentId, body) => {
  return axios.post(`/api/admin/investments/${investmentId}/mature`, body, { headers: authHeader() });
};

const registerNotificationToken = (data) => {
  return axios.post('/api/notifications/token', data, {
    headers: authHeader(),
  });
};

const sendAssetRepaymentReminder = (requestId) => {
  return axios.post(`/api/admin/asset/requests/${requestId}/repayments/schedule/reminder`, {}, {
    headers: authHeader(),
  });
};

const sendAssetRepaymentMessage = (requestId, data) => {
  return axios.post(`/api/admin/asset/requests/${requestId}/repayments/schedule/message`, data, {
    headers: authHeader(),
  });
};

const createTaxProfile = (data) => {
  return axios.post('/api/admin/tax-profiles', data, { headers: authHeader() });
};

const createInsuranceProfile = (data) => {
  return axios.post('/api/admin/insurance-profiles', data, { headers: authHeader() });
};

const postService = {
    createInsuranceProfile,
    createTaxProfile,
    matureInvestment,
    Logout,
    createSavingsCategory,
    reconcileWalletFunding,
    addRate,
    createInvestmentCategory,
    createAssestCategory,
    reset2fa,
    updateProject,
    updateProperty,
    changeRole,
    deactivateAdminUser,
    activateAdminUser,
    setupTransactionPin,
    userLogin,
    uploadProject,
    uploadProperty,
    uploadProjectt,
    uploadPropertyListing,
    uploadlandListing,
    userInvite,
    userCompleteSignup,
    activateUser,
    deactivateUser,
    changePin,
    changePassword,
    forgetPassMail,
    conForgetPassMail,
    addNotification,
    validateOtp,
    resetOtpp,
    forgetPin,
    uploadAsset,
    approveAssetRecommendation,
    CreateInvestmentPlan,
    registerNotificationToken,
    sendAssetRepaymentReminder,
    sendAssetRepaymentMessage
}

export default postService
